import React, { Component } from 'react';
import { connect } from "react-redux";
import {Link} from "react-router-dom";
import TextForm from "./TextForm";
import TextareaForm from "./TextareaForm";
import Required from "./Required";

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class FormAccordion extends Component {

    constructor(props) {
        super(props);
        this.handleOnClick=this.handleOnClick.bind(this);


        this.state={
            clicked:false,

        }
    }

    componentWillMount() {
        if(typeof this.props.clicked!=="undefined"){
            this.setState({
                clicked:this.props.clicked
            });
        }
    }


    handleOnClick(){


        this.setState({
            clicked: !this.state.clicked
        });


    }

    render() {
        const { t } = this.props;




        return (
            <React.Fragment>


                <div className="hv-accordion-container">
                    <Link to="" onClick={() => this.handleOnClick()} className={"accordion-link "+(this.state.clicked===true ? "menu-toggle": "")}>

                        <div className=" hv-form-accordion-inner settings-code-block-clean ">
                            <div>
                                <h6 className=" title">{this.props.title}</h6>
                            </div>
                            <div className="removeFormButtonDiv">
                                <button className="removeFormAccordion" onClick={()=>this.props.removeForm(this.props.index,this.props.id)}>
                                    <i className='bx bxs-trash-alt'></i>
                                </button>
                            </div>


                        </div>
                    </Link>
                    {this.state.clicked === true &&
                        <div className="hv-accordion-container-component">
                            {this.props.type == "text" &&
                                <TextForm index={this.props.index} error={this.props.error} labelname={this.props.labelname} setValue={this.props.setValue} defaultv={this.props.defaultv}/>

                            }
                            {this.props.type == "textarea" &&
                                <TextareaForm index={this.props.index} error={this.props.error} labelname={this.props.labelname} setValue={this.props.setValue} defaultv={this.props.defaultv}/>
                            }
                            {this.props.required === true &&
                             <Required is_required={this.props.is_required} changeRequired={this.props.changeRequired} index={this.props.index}/>
                            }
                        </div>
                    }
                </div>
            </React.Fragment>

        );
    }
}

export default FormAccordion;
